export const customComponentDefaultValues = {
  groups: [],
  cohort: [],
  roadmaps_info: [],
  coach: [],
  is_approved: true,
};
